import { SxProps, Theme } from "@mui/material";

export const reactionsContainerStyles: SxProps = {
  display: "flex",
  gap: 2,
  mb: 2,
};

export const getReactionButtonStyles =
  (isActive: boolean): SxProps<Theme> =>
  (theme: Theme) => ({
    px: "2px",
    py: "4px",
    borderRadius: "999px",
    textTransform: "none",
    transition: "background-color 0.2s ease-in-out",
    backgroundColor: isActive ? "#06B6D4" : theme.palette.panelInfo.tab.bg,
    color: isActive ? "#fff" : theme.palette.panelInfo.tab.color,
    "&:hover": {
      backgroundColor: isActive ? "#06B6D4" : theme.palette.panelInfo.tab.bg,
    },
  });

export const reactedMessageBoxStyles: SxProps<Theme> = (theme) => ({
  background: theme.palette.panelInfo.message.bg,
  p: 2,
  borderRadius: 2,
  cursor: "pointer",
  transition: "background-color 0.2s ease-in-out",
  overflow: "hidden",
  minWidth: 0,
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.message.bgHover,
  },
});

export const markdownContainerStyles: SxProps = {
  fontFamily: '"Red Hat Display", sans-serif',
  minWidth: 0,
  overflowWrap: "break-word",
  wordBreak: "break-word",
  overflow: "hidden",
  "& *": {
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
};

export const reactedMessagesListStyles: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  minWidth: 0,
};

export const reactedMessageFooterStyles: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "4px",
};

export const lessonBadgeStyles: SxProps<Theme> = (theme) => ({
  fontWeight: 500,
  fontSize: "12px",
  px: 1,
  py: 0.5,
  borderRadius: 1,
  backgroundColor: theme.palette.secondary.light,
  color: theme.palette.secondary.contrastText,
});

export const imageCollectionBoxStyles: SxProps = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: 1,
  minWidth: 0,
};

export const textWrapperStyles: SxProps = {
  minWidth: 0,
  flex: 1,
  overflowWrap: "break-word",
  wordBreak: "break-word",
  overflow: "hidden",
  "& *": {
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
};
